export default "__VITE_PUBLIC_ASSET__eaef11d5__"